export const help = {
  name: "help" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.776 15.852c-.312-3.952 4.914-4.134 4.914-8.554 0-2.678-2.158-4.888-5.746-4.888-2.522 0-4.68 1.222-6.084 3.484l2.366 1.82c1.04-1.508 2.184-2.34 3.692-2.34 1.534 0 2.496.936 2.496 2.106 0 3.042-5.408 3.146-4.368 8.372h2.73Zm-1.378 5.382c1.092 0 2.054-.962 2.054-2.028 0-1.04-.962-2.028-2.054-2.028-1.092 0-2.054.988-2.054 2.028 0 1.066.962 2.028 2.054 2.028Z"/></svg>`,
  keywords: ["help"],
  category: "status" as const,
};
